import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import BASE_URL from "../Config/apiConfig";
import { Link } from "react-router-dom";
import { FaHeart, FaStar } from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SimilarProduct = () => {
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const sliderRef = useRef();

  // 👤 User
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;
  const wishlistKey = userId ? `wishlist_${userId}` : null;

  // ⭐ Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/getAllProduct`);
        setProducts(res.data.result || []);
      } catch (err) {
        console.error("Product fetch error:", err);
      }
    };
    fetchProducts();
  }, []);

  // ❤️ Load Wishlist
  useEffect(() => {
    if (!wishlistKey) return;
    const data = JSON.parse(localStorage.getItem(wishlistKey)) || [];
    setWishlist(data);
  }, [wishlistKey]);

  // ❤️ Toggle Wishlist
  const toggleWishlist = (product) => {
    let updatedWishlist = [...wishlist];

    const index = updatedWishlist.findIndex(
      (item) => item._id === product._id
    );

    if (index > -1) {
      updatedWishlist.splice(index, 1);
    } else {
      updatedWishlist.push({
        _id: product._id,
        pName: product.pName,
        pImg: product.pImg,
        price: product.price,
      });
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
  };

  // ⬅➡ Scroll
  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <div className="py-16 mt-5">
      <div className="max-w-[1400px] mx-auto px-4">

        {/* TITLE */}
        <h2 className="text-center text-[28px] sm:text-[34px] lg:text-[40px] font-bold text-[#187685] mb-14 tracking-wide">
           Our Featured Medicines
        </h2>

        {/* SLIDER */}
        <div className="relative">

          {/* ⬅ Left Button */}
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 backdrop-blur-md shadow-lg p-3 rounded-full hover:scale-110 transition"
          >
            <ChevronLeft className="text-[#187685]" />
          </button>

          {/* ➡ Right Button */}
          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 backdrop-blur-md shadow-lg p-3 rounded-full hover:scale-110 transition"
          >
            <ChevronRight className="text-[#187685]" />
          </button>

          {/* Slider Track */}
          <div
            ref={sliderRef}
            className="flex gap-6 overflow-x-auto scroll-smooth scrollbar-hide px-10"
          >
            {products.map((product) => {
              const isWishlisted = wishlist.some(
                (item) => item._id === product._id
              );

              return (
                <div
                  key={product._id}
                  className="min-w-[230px] bg-white/80 backdrop-blur-lg border border-gray-100 rounded-[26px] p-4  hover:shadow-xl transition-all duration-300 group relative"
                >

                  {/* ❤️ Wishlist */}
                  <div
                    onClick={() => toggleWishlist(product)}
                    className="absolute top-4 right-4 cursor-pointer"
                  >
                    <FaHeart
                      size={20}
                      className={`transition ${
                        isWishlisted
                          ? "text-red-500 scale-110"
                          : "text-gray-300 group-hover:text-red-400"
                      }`}
                    />
                  </div>

                  {/* Image */}
                  <Link to={`/product/${product._id}`} state={{ product }}>
                    <div className=" rounded-[20px] h-[200px] flex items-center justify-center overflow-hidden">
                      <img
                        src={`https://mediapi.onlinepharmaque.in/uploads/${product.pImg?.[0]}`}
                        alt={product.pName}
                        className=" object-contain group-hover:scale-110 transition duration-300"
                      />
                    </div>
                  </Link>

                  {/* Name */}
                  <p className="mt-4 text-[15px] font-semibold text-gray-800 line-clamp-2 group-hover:text-[#187685] transition">
                    {product.pName}
                  </p>

                  {/* ⭐ Rating + Price */}
                  <div className="mt-3 flex items-center justify-between">

                    {/* Rating Badge */}
                    <div className="inline-flex items-center gap-1 px-3 py-[3px] rounded-full bg-[#fff8e6] border border-[#FFE8B3]">
                      <span className="text-sm font-semibold text-gray-900">
                        {Number(product?.ratestar || 0).toFixed(1)}
                      </span>
                      <FaStar className="text-[#FFA41C] text-xs" />
                    </div>

                    {/* Price */}
                    {product.price && (
                      <span className="text-sm font-bold text-[#187685]">
                        ₹{product.price}
                      </span>
                    )}
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimilarProduct;